// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"749730f4","703":"7927f7e6"}[chunkId] + ".chunk.js";
};